function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 42,
  cy: 42,
  r: 42,
  fill: "#fff"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.855 24.177V58.178h-31.91V24.177h31.91V14h-19.56L16 31.652v11.334c0 14.807 11.878 27.298 26.348 27.01C56.44 69.753 67.8 57.937 67.8 43.515v-19.34h-9.945z",
  fill: "#6932D4"
});

var SvgUtrust = function SvgUtrust(props) {
  return React.createElement("svg", _extends({
    width: 84,
    height: 84,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODQiIGhlaWdodD0iODQiIHZpZXdCb3g9IjAgMCA4NCA4NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNDIiIGN5PSI0MiIgcj0iNDIiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik01Ny44NTQ4IDI0LjE3NjVWMzIuODA5N1Y1OC4xNzg3SDI1Ljk0NTJWMzEuMTY5OVYyNC4xNzY1SDU3Ljg1NDhWMTRIMzguMjk0M0wxNiAzMS42NTIyVjQyLjk4NjJDMTYgNTcuNzkyOCAyNy44Nzc3IDcwLjI4NDIgNDIuMzQ3OCA2OS45OTUxQzU2LjQ0MDcgNjkuNzUzOSA2Ny44IDU3LjkzNzUgNjcuOCA0My41MTY4VjI0LjE3NjVINTcuODU0OFoiIGZpbGw9IiM2OTMyRDQiLz4KPC9zdmc+Cg==";
export { SvgUtrust as ReactComponent };